import type { WorkspaceReference, ResolvedReference } from "./references.api";
import { http } from "./http";
export type MeetingDecision = {
  reference?: WorkspaceReference | null;
  id: string;
  title: string;
  body: string;
  assigneeId?: string;
  dueDate?: string;
};
export type MeetingContent = {
  references?: WorkspaceReference[];
  title: string;
  startsAt: string;
  endsAt?: string;
  timeZone?: string;
  agenda: string;
  minutes: string;
  participantIds: string[];
  decisions: MeetingDecision[];
};
export type MeetingSummary = {
  id: string;
  title: string;
  startsAt: string;
  version: number;
  publishedAt: string | null;
};
export type Meeting = MeetingContent &
  MeetingSummary & {
    resolvedReferences?: ResolvedReference[];
    canEdit: boolean;
    canConvert: boolean;
    links: { decisionId: string; taskId: string }[];
  };
export type MeetingFilters = {
  search?: string;
  status?: string;
  from?: string;
  to?: string;
  participant?: string;
  sort?: string;
};
const base = "/v1/workspace/meetings";
export const meetingsApi = {
  list: async (page: number, filters: MeetingFilters = {}) =>
    (
      await http.get<{ items: MeetingSummary[]; hasMore: boolean }>(base, {
        params: { page, ...filters },
      })
    ).data,
  get: async (id: string) => (await http.get<Meeting>(base + "/" + id)).data,
  members: async () =>
    (
      await http.get<
        { id: string; firstName: string; lastName: string; role: string }[]
      >(base + "/members")
    ).data,
  create: async (data: MeetingContent & { requestId: string }) =>
    (await http.post<{ id: string }>(base, data)).data,
  update: async (id: string, data: MeetingContent & { version: number }) =>
    (await http.patch(base + "/" + id, data)).data,
  publish: async (id: string, version: number) =>
    (await http.post(base + "/" + id + "/publish", { version })).data,
  convert: async (id: string, decision: string) =>
    (
      await http.post<{ id: string }>(
        base + "/" + id + "/decisions/" + decision + "/task",
      )
    ).data,
  origin: async (id: string) =>
    (
      await http.get<{ id: string; title: string } | null>(
        base + "/task-origin/" + id,
      )
    ).data,
};
